import { Form, Formik } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export interface SearchBoxProps {
  className: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  t: (key: string) => string;
}
const SearchBox = ({ className, onChange, t }: SearchBoxProps) => (
  <div className={className}>
    <div className="search">
      <Formik initialValues={{ searchInput: '' }} onSubmit={values => {}}>
        {({ handleBlur }) => (
          <Form className="search-form d-flex justify-content-center">
            <input
              type="text"
              placeholder={t('f:dataRoom.search')}
              onChange={onChange}
              onBlur={handleBlur}
              name="searchInput"
            />
            <button
              title={t('f:dataRoom.search')}
              className="button-main button-primary"
              type="submit"
            >
              <FontAwesomeIcon icon={['fas', 'search']} size="lg" />
            </button>
          </Form>
        )}
      </Formik>
    </div>
  </div>
);
export default SearchBox;
